/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas20Scopes extends ExtensibleNode {
    /*private*/ items : any = <any>({});

    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitScopes(this);
    }

    /**
     * Returns all the scopes.
     * @return {string[]}
     */
    public getScopeNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        return rval;
    }

    /**
     * Gets a scope description.
     * @param {string} scope
     * @return {string}
     */
    public getScopeDescription(scope : string) : string {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, scope);
    }

    /**
     * Adds a scope to the map.
     * @param {string} scope
     * @param {string} description
     */
    public addScope(scope : string, description : string) {
        /* put */(this.items[scope] = description);
    }

    /**
     * Removes a scope.
     * @param {string} scope
     * @return {string}
     */
    public removeScope(scope : string) : string {
        return /* remove */(map => { let deleted = this.items[scope];delete this.items[scope];return deleted;})(this.items);
    }
}
Oas20Scopes["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Scopes";
Oas20Scopes["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




